import * as React from 'react';

const IconAccount = (props) => (
    <svg
        width={36}
        height={36}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z"
            fill="#F0F0F1"
        />
        <path
            d="M9.242 23.062v-1a1 1 0 0 0-.865 1.502l.865-.502Zm17.516 0 .865.502a1 1 0 0 0-.865-1.502v1ZM24.062 18a6.062 6.062 0 0 0-3.742-5.601l-.765 1.848A4.063 4.063 0 0 1 22.062 18h2Zm-3.742-5.601a6.062 6.062 0 0 0-6.607 1.314l1.414 1.414a4.062 4.062 0 0 1 4.428-.88l.765-1.848Zm-6.607 1.314A6.062 6.062 0 0 0 12.4 20.32l1.848-.765a4.063 4.063 0 0 1 .88-4.428l-1.414-1.414ZM12.4 20.32a6.063 6.063 0 0 0 5.6 3.742v-2a4.062 4.062 0 0 1-3.752-2.507l-1.848.765Zm5.6 3.742A6.062 6.062 0 0 0 24.063 18h-2A4.062 4.062 0 0 1 18 22.062v2Zm.001-2H9.242v2H18v-2Zm-9.623 1.502A11.125 11.125 0 0 0 18 29.107v-2a9.125 9.125 0 0 1-7.893-4.546l-1.73 1.003ZM18 29.107c3.966 0 7.633-2.112 9.623-5.543l-1.73-1.003A9.125 9.125 0 0 1 18 27.107v2Zm8.758-7.045H18v2h8.758v-2Z"
            fill="#A2A2A8"
        />
        <path
            d="M7.875 18c0-5.592 4.533-10.125 10.125-10.125S28.125 12.408 28.125 18"
            stroke="#A2A2A8"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default IconAccount;
